export enum EColors {
  white = '#FFFFFF',
  whiteSmoke = '#F5F5F5',
  magnolia = '#F6F5F7',
  paket = '#3C82FF',
  withdrawal = '#6C737D',
  whiteOpacity0d35 = '#ffffff59',
  whiteOpacity0d15 = '#ffffff26',
  whiteOpacity0d80 = '#FFFFFFCC',
  magnoliaDark = '#EEEDF0',
  whisper = '#E5E5E5',
  titanWhite = '#D8D7D9',
  skeletonGray = '#E8E8E8',
  blackOpacity0d01 = '#0000001a',
  blackOpacity0d72 = '#000000b8',
  blackOpacity0d48 = '#0000007a',
  lightGrey = '#D0D0D0',
  silver = '#C5C5C5',
  lightSilver = '#C1C1C1',
  nobel = '#959595',
  greySuit = '#9B9A9D',
  blackOpacity0d35 = '#00000059',
  topaz = '#78767B',
  dimGray = '#6F6F6F',
  grayStart = '#A4A4A4',
  grayEnd = '#CBD2DB',
  grayLight = '#BCC4CF',
  cloudedVision = '#D1D1D1',
  nightRider = '#333333',
  haiti = '#302E33',
  black = '#000000',
  amour = '#FFEAEC',
  sunsetOrange = '#F2483C',
  salmonRed = '#FF796E',
  extraRed = '#F2483D',
  darkExtraRed = '#D13535',
  persianRed = '#E52322',
  freeSpeechRed = '#D91411',
  nightShadz = '#A44445',
  wellRead = '#903739',
  bubbles = '#E4F9EB',
  pigmentGreen = '#00923A',
  britishRacingGreen = '#084021',
  nero = '#292929',
  disablePersianRed = '#E58484',
  mediumSeaGreen = '#36B368',
  maxSeaGreen = '#B1D941',
  greenLawn = '#5faf2d',
  warningOrange = '#EF9312',
  lightningYellow = '#ffa82e',
  warningOrangeActive = '#CF851D',
  warningLight = '#C7A069',
  tangerineYellow = '#FFCC00',
  blueSky = '#E8F7FE',
  rusticRed = '#41121A',
  pohutukawa = '#5E0B1A',
  darkGreen = '#022C0F',
  supernova = '#FFAD26',
  lightGreen = '#e7f6ec',
  darkGrey = '#464646',
  grey = '#222429',
  /* Mystery Shopper colors */
  mysteryBlack = '#111319',
  mysteryBgBlack = '#1C1E26',
  mysteryDarkBlue = '#232630',
  mysteryMediumBlue = '#2F3340',
  mysteryLightBlue = '#454A59',
  mysteryDarkGray = '#888B9A',
  mysteryLightGray = '#BCC0CC',
  mysteryLightGrayOpacity0d16 = '#BCC0CC29',
  mysteryWhite = '#FAFBFC',
  mysteryDark = '#00000052',
  persianRedShadow = '#D7382D',
  kellyGreen = '#26BF0D',
  expressPoints = '#FF6917',
  burningPoints = '#FF7B1C',
  parisDaisy = '#F0E346',
  darkSpringGreen = '#13753c',
  darkestSpringGreen = '#0A5E2D',
  /* Loyalty Clubs colors */
  fluffy = '#e52322',
  kids = '#0033a1',
  bar = '#96224B',
  lightBlue = '#E1F2FE',
  /* redesign v2 colors */
  blackMana = '#858585',
  buttonSecondary = '#F4F4F5',
  buttonSecondaryPressed = '#CBCBCC',
  blueLighten = '#E6F2FF',
  greenLighten = '#EDF6EC',
  iconSecondary = '#A6A6A7',
  /*v2 new colors */
  orangeDuck = '#FFA500',
  blackOpacity0d24 = '#0000003d',
  blackOpacity0d12 = '#0000001f',
  aliceBlue = '#F6F7F8',
  extraPurple = '#7e4aec',
  vividOrange = '#f76100',
  grass = '#5faf2c',
  guidingStar = '#ffe8da',
  weatheredMoss = '#BBBBB1',
  redLighten = '#FCE9E9',
  lovingFrog = '#48A83F',
  rose = '#F4A5A4',
  /* loyalty redesign v2 colors */
  grey1C = '#D9D9D6',
  grey5C = '#B1B3B3',
  grey9C = '#75787B',
  greenSecondary = '#AAE641',
  loyaltyGreen = '#5FAF2C',
  greenAdditional10 = '#EBFAE1',
  blueAdditional10 = '#EBF5FF',
  blueAdditional40 = '#99CFFF',
  bluePrimary = '#0088FE',
  apelsinPrimary = '#F76100',
  apelsinPressed = '#e05800',
  apelsinDisabled = '#ffa282',
  apelsinHover = '#ff7b4c',
  apelsinSecondary = '#bbbbb1',
  sheerPeach = '#fff6e6',
  placeboPurple = '#f2edfd',
  poweredPuff = '#feeef4',
  placeboLime = '#f5fbe9',
  calmWaters = '#e6fafa',
  greenSerum = '#99d620',
  pansy = '#f25090',
}
